import React from "react";
import Box from "./base/Box";
import { SENTIMENT } from "../utilities/constants";

const SentimentLabel = ({ sentiment = null, sx, ...props }) => {
  let labelColors = {};
  let label = "-";
  switch (sentiment) {
    case SENTIMENT.POSITIVE:
      labelColors = {
        color: "#14804A",
        backgroundColor: "#bdffde",
      };
      label = sentiment;
      break;
    case SENTIMENT.NEGATIVE:
      labelColors = {
        color: "#a90202",
        backgroundColor: "#ffd0d0",
      };
      label = sentiment;
      break;
    case SENTIMENT.NEUTRAL:
      label = sentiment;
    default:
      labelColors = {
        color: "darkslategray",
        backgroundColor: "lightgray",
      };
  }

  return (
    <Box
      sx={{
        textAlign: "center",
        borderRadius: 20,
        textTransform: "capitalize",
        padding: "5px 10px",
        width: "fit-content",
        ...labelColors,
        ...sx,
      }}
      {...props}
    >
      {label}
    </Box>
  );
};

export default SentimentLabel;
